var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"outline-secondary","size":"sm","disabled":_vm.copied},on:{"click":_vm.copyContent}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.copied)?_c('i',{staticClass:"fa fa-check ml-1"}):_c('i',{staticClass:"far fa-copy ml-1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }